'use client';

import { createUuid } from '@common/utils';
import { useSuspenseQuery } from '@tanstack/react-query';

import { COMMENT_TYPE } from '@/api';
import { getCommentList } from '@/api/getCommentList';
import { CommentListWithField } from '@/components/template/CommentListWithField';

import { useGetHometownNewsRelatedList as getHometownNewsRelatedList } from '../[id]/_hooks/useGetHometownNewsRelatedList';
import { HometownNewsDetailBottomDrawer } from './HometownNewsDetailBottomDrawer';
import { ImageFloatingBanner } from './ImageFloatingBanner';
import { MoreFloatingButton } from './MoreFloatingButton';
import { RecommendHometownNews } from './RecommendHometownNews';

interface MoreHometownNewsListProps {
  id: number;
  idx: string;
  contentAreaId: string;
}

export const MoreHometownNewsList = ({
  id,
  idx,
  contentAreaId,
}: MoreHometownNewsListProps) => {
  const hometownNewsRelated = useSuspenseQuery({
    queryKey: ['getHometownNewsRelatedList', idx],
    queryFn: async () => {
      const {
        list: hometownNewsRelatedList,
        keyword: hometownNewsRelatedListKeyword,
      } = await getHometownNewsRelatedList({ idIdx: idx });

      return { hometownNewsRelatedList, hometownNewsRelatedListKeyword };
    },
  });
  const { hometownNewsRelatedList, hometownNewsRelatedListKeyword } =
    hometownNewsRelated.data;

  const isNotRenderRelatedList = hometownNewsRelatedList.length > 0;

  const initialComment = useSuspenseQuery({
    queryKey: ['getCommentList', id],
    queryFn: async () =>
      await getCommentList({
        commentType: COMMENT_TYPE.HOMETOWN_NEWS,
        id,
      }),
  });

  const initialCommentData = initialComment.data;

  const recommendHometownNewsAreaId = createUuid();

  return (
    <>
      {isNotRenderRelatedList ? (
        <RecommendHometownNews
          id={recommendHometownNewsAreaId}
          list={hometownNewsRelatedList}
        />
      ) : null}
      <CommentListWithField
        commentType={COMMENT_TYPE.HOMETOWN_NEWS}
        contentId={id}
        initialData={initialCommentData}
      />
      {isNotRenderRelatedList ? (
        <MoreFloatingButton
          contentAreaSelector={contentAreaId}
          keyword={hometownNewsRelatedListKeyword}
          recommendHometownNewsSelector={recommendHometownNewsAreaId}
        />
      ) : null}
      <ImageFloatingBanner />
      <HometownNewsDetailBottomDrawer />
    </>
  );
};
